import styled from 'styled-components'
import { px2rems } from '../tools/functions'

export const H1 = styled.h1`
  font-size: ${px2rems(28)};
`
export const H2 = styled.h2`
  font-size: ${px2rems(23)};
`
export const H3 = styled.h3`
  font-size: ${px2rems(19)};
`
export const H4 = styled.h4`
  font-size: ${px2rems(16)};
`
export const H5 = styled.h5`
  font-size: ${px2rems(13)};
`
export const H6 = styled.h6`
  font-size: ${px2rems(11)};
`



// WEBPACK FOOTER //
// ./src/style/styled-components/elements/Headings.jsx